import { useEffect } from 'react';
import { useConfig } from '../config/ConfigContext';

const Analytics = () => {
  const { config } = useConfig();

  useEffect(() => {
    if (!config?.analytics?.enabled) return;

    // Google Analytics
    if (config.analytics.googleAnalyticsId) {
      // Load Google Analytics
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${config.analytics.googleAnalyticsId}`;
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${config.analytics.googleAnalyticsId}');
      `;
      document.head.appendChild(script2);

      // Make gtag available globally for tracking events
      window.gtag = window.gtag || function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(arguments);
      };
    }

    // Facebook Pixel
    if (config.analytics.facebookPixelId) {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${config.analytics.facebookPixelId}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);

      // Make fbq available globally
      window.fbq = window.fbq || function() {
        window.fbq.queue = window.fbq.queue || [];
        window.fbq.queue.push(arguments);
      };
    }

  }, [config]);

  return null;
};

// Helper functions for tracking events
export const trackEvent = (eventName, parameters = {}) => {
  // Google Analytics
  if (window.gtag) {
    window.gtag('event', eventName, parameters);
  }
  
  // Facebook Pixel
  if (window.fbq) {
    window.fbq('track', eventName, parameters);
  }
};

export const trackPurchase = (orderId, value, items = []) => {
  const purchaseData = {
    transaction_id: orderId,
    value: value,
    currency: 'USD',
    items: items
  };

  trackEvent('purchase', purchaseData);
};

export const trackAddToCart = (productId, productName, value) => {
  const cartData = {
    currency: 'USD',
    value: value,
    items: [{
      item_id: productId,
      item_name: productName,
      quantity: 1
    }]
  };

  trackEvent('add_to_cart', cartData);
};

export default Analytics;